import { Component } from "@angular/core";
import { Constants } from "src/app/constants";
import { HomeService } from "src/services/home/home.service";

@Component({
    selector:'app-preguntas-frecuentes',
    templateUrl:'./preguntas-frecuentes.component.html',
    styleUrls:['./preguntas-frecuentes.component.css']
})
export class PreguntasFrecuentesComponent{
    titulo = Constants.FAQ;
    public appData : any ;
    
    expandedQuestion: string | null = null;
    preguntasFrecuentes: any;

    constructor(
        private HomeService:HomeService
    ){
        this.appData = this.HomeService.getEnvironment();
        this.preguntasFrecuentes = this.appData.licenseData.preguntasFrecuentes;
    }

    toggleQuestion(pregunta: string) {
        this.expandedQuestion = this.expandedQuestion === pregunta ? null : pregunta;
    }
}